import { STORY_STATUS_LABEL, type StoryStatus } from '../../lib/api/abnahme';
import { STORY_STATUS_KLASSE } from '../../lib/abnahme/statusKlasse';

/** Stand einer Story als farbiges Etikett — gleich in Katalog und Detail. */
export default function StoryStatusBadge({ status }: { status: StoryStatus }) {
  return (
    <span className={`inline-flex rounded px-2 py-0.5 text-xs font-medium ${STORY_STATUS_KLASSE[status] ?? ''}`}>
      {STORY_STATUS_LABEL[status] ?? status}
    </span>
  );
}
